import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82001e3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "card-body mb-0 pb-0" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cube me-2" }),
  /*#__PURE__*/_createTextVNode("ชื่อโครงการ:")
], -1))
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-star me-2" }),
  /*#__PURE__*/_createTextVNode("สถานะ:")
], -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-percent me-2" }),
  /*#__PURE__*/_createTextVNode("ร้อยละของผลงาน:")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "progress",
  style: {"margin-top":"3px"}
}
const _hoisted_12 = ["aria-valuenow"]
const _hoisted_13 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-percent me-2" }),
  /*#__PURE__*/_createTextVNode("ร้อยละการเบิกจ่าย:")
], -1))
const _hoisted_16 = {
  key: 0,
  class: "progress",
  style: {"margin-top":"3px"}
}
const _hoisted_17 = ["aria-valuenow"]
const _hoisted_18 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่สิ้นสุดโครงการ:")
], -1))
const _hoisted_20 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-clock me-2" }),
  /*#__PURE__*/_createTextVNode("ระยะเวลาดำเนินการ:")
], -1))
const _hoisted_23 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_24 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-dollar-sign me-2" }),
  /*#__PURE__*/_createTextVNode("เบิกจ่ายคงเหลือ:")
], -1))
const _hoisted_27 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment me-2" }),
  /*#__PURE__*/_createTextVNode("การสั่งการ/เร่งรัดโครงการ:")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban me-2" }),
  /*#__PURE__*/_createTextVNode("การยกเลิกโครงการ")
], -1))
const _hoisted_32 = { class: "card-body mb-0 pb-0" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่ยกเลิก:")
], -1))
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = { class: "col-sm-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารการยกเลิกโครงการ:")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("สาเหตุการยกเลิก:")
], -1))
const _hoisted_40 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectCommentOffcanvasComponent = _resolveComponent("ProjectCommentOffcanvasComponent")!
  const _component_ProjectCancelAttachmentOffcanvasComponent = _resolveComponent("ProjectCancelAttachmentOffcanvasComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["card mt-2 mb-3", {'card-danger': _ctx.project?.isCanceled}])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.project?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("p", null, null, 512), [
              [_directive_dompurify_html, _ctx.status(_ctx.project?.isCanceled, _ctx.project?.projectStatus.name, _ctx.project?.projectStatus.color)]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              (_ctx.project?.projectStatus.key > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: "progress-bar progress-bar-striped",
                      role: "progressbar",
                      style: _normalizeStyle({ width: _ctx.project?.projectResult?.percent + '%' }),
                      "aria-valuenow": _ctx.project?.projectResult?.percent,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, _toDisplayString(Number(_ctx.project?.projectResult?.percent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + "% ", 13, _hoisted_12)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_13, "ไม่มีข้อมูล"))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              (_ctx.project?.projectStatus.key > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", {
                      class: "progress-bar progress-bar-striped",
                      role: "progressbar",
                      style: _normalizeStyle({ width: _ctx.project.projectResult?.totalSpent / _ctx.project?.projectResult?.realBudget * 100 + '%' }),
                      "aria-valuenow": _ctx.project.projectResult?.totalSpent / _ctx.project?.projectResult?.realBudget * 100,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, _toDisplayString(Number(_ctx.project.projectResult?.totalSpent / _ctx.project?.projectResult?.realBudget * 100).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + "% ", 13, _hoisted_17)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_18, "ไม่มีข้อมูล"))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["col-sm-6", {'d-none': _ctx.project?.projectResult?.endDate.toISOString() === '1901-01-01T17:00:00.000Z'}])
            }, [
              _hoisted_19,
              (_ctx.project?.projectStatus.key > 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.thaiDate(_ctx.project?.projectResult?.endDate)), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_21, "ไม่มีข้อมูล"))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-sm-6", {'d-none': _ctx.project?.projectResult?.endDate.toISOString() === '1901-01-01T17:00:00.000Z'}])
            }, [
              _hoisted_22,
              (_ctx.project?.projectStatus.key > 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.project?.projectResult?.remaining) + " วัน", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_24, "ไม่มีข้อมูล"))
            ], 2),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              (_ctx.project?.projectStatus.key > 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(Number(_ctx.project?.projectResult?.realBudget - _ctx.project?.projectResult?.totalSpent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท ", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_28, "ไม่มีข้อมูล"))
            ]),
            (_ctx.showEnjoins)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showComment && _ctx.showComment(...args)), ["stop","prevent"]))
                    }, " ดูการสั่งการ/เร่งรัดโครงการ ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2),
      (_ctx.project?.isCanceled)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_31,
            _createElementVNode("div", {
              class: _normalizeClass(["card mt-2", {'card-danger': _ctx.project?.isCanceled}])
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.cancel ? _ctx.thaiDate(_ctx.cancel?.canceledDate) : ''), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("p", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAttachment && _ctx.showAttachment(...args)), ["stop","prevent"]))
                      }, " ดูเอกสารการยกเลิกโครงการ ")
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("p", _hoisted_40, null, 512), [
                    [_directive_dompurify_html, _ctx.cancel?.remark ? _ctx.cancel?.remark.replace(/\n/g, '<br />') : '-']
                  ])
                ])
              ])
            ], 2)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ProjectCommentOffcanvasComponent, {
      ref: "projectCommentOffcanvas",
      "project-id": _ctx.project?.id
    }, null, 8, ["project-id"]),
    _createVNode(_component_ProjectCancelAttachmentOffcanvasComponent, {
      ref: "projectCancelAttachmentOffcanvas",
      "project-id": _ctx.project?.id
    }, null, 8, ["project-id"])
  ], 64))
}